import React from 'react';
import { Gem, Home, Briefcase, Film, Image, LogIn, LogOut } from 'lucide-react';

// Labels and order are fixed (Home, Projects, Reviews, Gallery, Admin/Logout).
// Below 640px the labels collapse to icons, each with an accessible name.
const NAV_ITEMS = [
  { page: 'home', label: 'Home', icon: Home },
  { page: 'projects', label: 'Projects', icon: Briefcase },
  { page: 'reviews', label: 'Reviews', icon: Film },
  { page: 'gallery', label: 'Gallery', icon: Image },
];

const itemClass =
  'flex h-10 items-center gap-2 rounded-full px-2.5 text-sm transition-colors duration-150 ease-out sm:px-3';

const Navigation = ({ currentPage, setCurrentPage, setShowAdminModal, isAuthenticated, onLogout, currentUser }) => {
  return (
    <nav className="sticky top-0 z-40 h-16 border-b border-white/5 bg-slate-950">
      <div className="page flex h-full items-center justify-between gap-2">
        <div className="flex items-center gap-2 font-semibold tracking-tight text-slate-50">
          <Gem size={20} strokeWidth={1.75} className="text-sky-400" />
          <span>Nabil Hamid</span>
        </div>

        <div className="flex items-center gap-0.5 sm:gap-1">
          {NAV_ITEMS.map(({ page, label, icon: Icon }) => {
            const active = currentPage === page;
            return (
              <button
                key={page}
                type="button"
                onClick={() => setCurrentPage(page)}
                aria-label={label}
                aria-current={active ? 'page' : undefined}
                className={`${itemClass} ${
                  active ? 'bg-white/[0.06] text-slate-50' : 'text-slate-400 hover:text-slate-100'
                }`}
              >
                <Icon size={18} strokeWidth={1.75} className="sm:hidden" />
                <span className="hidden sm:inline">{label}</span>
              </button>
            );
          })}

          {isAuthenticated ? (
            <div className="ml-1 flex items-center gap-2">
              <span className="hidden max-w-[160px] truncate text-sm text-slate-400 md:inline">
                {currentUser?.email}
              </span>
              <button
                type="button"
                onClick={onLogout}
                title="Logout"
                aria-label="Logout"
                className={`${itemClass} text-slate-300 ring-1 ring-inset ring-white/10 hover:text-slate-50`}
              >
                <LogOut size={18} strokeWidth={1.75} className="sm:hidden" />
                <span className="hidden sm:inline">Logout</span>
              </button>
            </div>
          ) : (
            <button
              type="button"
              onClick={() => setShowAdminModal(true)}
              aria-label="Admin"
              className={`${itemClass} ml-1 text-slate-400 ring-1 ring-inset ring-white/10 hover:text-slate-100`}
            >
              <LogIn size={18} strokeWidth={1.75} className="sm:hidden" />
              <span className="hidden sm:inline">Admin</span>
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
